import React from "react";
import './timeline.css';
import PossiblyEmptyLink from "./possiblyEmptyLink";
import { Row, Col } from 'react-bootstrap';


export class Timeline extends React.Component {
  /*
  When
  Emoji => appears before title
  Role => Title / TitleLink
  SupplementaryLinks - array of links
  Company => Subtitle
  Description (list) / DescriptionLine
  */
  render() {
    var supplements = this.props.SupplementaryLinks || [];
    return (
      <div className="timeline-item">
        <span className="duration">
          {this.props.When}
        </span>
        <Row className="timeline-content">
          { this.props.Logo && <Col md={3} lg={2} className={"timeline-img-column"}>
            <img
              className={"timeline-img"}
              src={this.props.Logo}
              alt=""/>
          </Col>}
          <Col md={9} lg={10} className="timeline-content-column">
            <div className="timeline-title">
              {this.props.Emoji}
              <PossiblyEmptyLink
                text={this.props.Title}
                href={this.props.TitleLink}
                alt_text={this.props.Title} />
            </div>

            <div className="timeline-subtitle">
              <PossiblyEmptyLink
                text={this.props.Subtitle}
                href={this.props.SubtitleLink}
                alt_text={this.props.Subtitle} />
                {supplements.map( (supplement, index) => (
                  <PossiblyEmptyLink
                    text={supplement.text}
                    href={supplement.link}
                    alt_text=""
                    is_icon={true}
                    hover_text={supplement.hover_text}
                    key={index} />
                ))}
            </div>

            <div className="timeline-description">
              {/*
                Only one of Description (array of strings)
                or DescriptionLine should be used.
              */}
              <ul>
                {this.props.Description?.map((line) => (
                  <li className="timeline-list-item" key={line}>
                    {line}
                  </li>
                ))}
              </ul>

              <p>
                {this.props.DescriptionLine}
              </p>
            </div>
          </Col>
        </Row>
      </div>
    );
  }
}

  export default Timeline;
